export enum GENDER_NAME {
  MALE = '男性',
  FEMALE = '女性',
}

export enum GENDER_KEY {
  MALE = '1',
  FEMALE = '0',
}
